const fr = {
  100000001:'Informations clés',
  100000002:'Nom du token',
  100000003:'Créateur de la copie',
  100000004:"Heure de création de l'instance",
  100000005:'Informations de base  ',
  100000006:'Blockchain/protocole associé  ',
  100000007:'Adresse du contrat intelligent  ',
  100000008:"Date d'émission",
  100000009:'Offre totale',
  100000010:'Offre en circulation',
  100000011:'Capitalisation boursière',
  100000012:'Données de marge',
  100000013:'Informations sur les réseaux sociaux',
  100000014:'Site web',
  100000015:'Livre blanc',
  100000016:'Explorateur blockchain  ',
  100000017:'Évaluation du projet',
  100000018:'Classement',
  100000019:'Top',
  100000020:'Code security',
  100000021:'Operation Performance',
  100000022:'Market Stability',
  100000023:'Governance Strength',
  100000024:'Project Health',
  100000025:'Community Trust',
  100000026:'Dernière mise à jour',
  100000027:'Note de sécurité  ',
  100000028:'Note de sécurité du contrat  ',
  100000029:'Statistiques des projets à risque  ',
  100000030:'Détails du code du contrat  ',
  100000031:"Taxe d'achat  ",
  100000032:'Taxe de vente  ',
  100000033:'Est un honeypot  ',
  100000034:'Peut être mint à nouveau  ',
  100000035:"Existence d'une liste noire  ",
  100000036:"Existence d'une liste blanche  ",
  100000037:'Est anti-baleine  ',
  100000038:"Peut modifier le taux d'imposition  ",
  100000039:'Est open source  ',
  100000040:'Existence de détenteurs cachés  ',
  100000041:"Peut s'autodétruire  ",
  100000042:'Est un contrat proxy  ',
  100000043:'Peut modifier le solde  ',
  100000044:'Peut exécuter des appels externes  ',
  100000045:'Peut récupérer la propriété  ',
  100000046:"Existence d'une période de refroidissement pour les transactions  ",
  100000047:'Peut suspendre les transferts  ',
  100000048:'Propriété non renoncée  ',
  100000049:'Est anti-baleine ajustable  ',
  100000050:'Trop de décimales  ',
  100000051:'Méthodes publiques de Mint et Burn  ',
  100000052:"Brûler des tokens met à jour l'offre totale  ",
  100000053:'Brûler des tokens met à jour le solde  ',
  100000054:'Transférer à soi-même augmente le solde  ',
  100000055:'Transférer plus de tokens que le solde sera invalide  ',
  100000056:"Le solde n'est pas mis à jour lors du transfert  ",
  100000057:'Le solde du destinataire sera consommé  ',
  100000058:'Appeler TransferFrom au-delà du solde échouera  ',
  100000059:"La méthode BurnFrom met à jour l'offre totale  ",
  100000060:"Détecter la taxe d'achat du jeton. Au-dessus de 5% est considéré comme un taux de taxe élevé.",
  100000061:'Détecter la taxe de vente du jeton. Au-dessus de 5% est considéré comme un taux de taxe élevé.',
  100000062:'Vérifier si le jeton est une arnaque de type honeypot.',
  100000063:'Vérifier si plus de jetons peuvent être créés.',
  100000064:"Vérifier si le jeton a une liste noire qui peut restreindre les utilisateurs d'échanger ou de transférer des jetons.",
  100000065:'Vérifier si le jeton a une liste blanche qui permet aux adresses de contourner les restrictions.',
  100000066:'Vérifier si le jeton a des mécanismes anti-baleines.',
  100000067:'Vérifier si le jeton a une taxe et si cette taxe peut être modifiée par des rôles privilégiés.',
  100000068:'Vérifier si le jeton a été vérifié sur un explorateur de blockchain.',
  100000069:'Vérifier si le jeton a un propriétaire caché qui peut manipuler le contrat, même si la propriété semble avoir été renoncée.',
  100000070:"Vérifier si le jeton peut s'autodétruire.",
  100000071:"Vérifier si le jeton est un contrat proxy qui délègue les appels de fonction à un contrat d'implémentation.",
  100000072:'Vérifier si le solde du jeton peut être modifié par des rôles privilégiés.',
  100000073:'Vérifier si le jeton appelle des contrats externes.',
  100000074:'Vérifier si le jeton a une porte dérobée pour reprendre la propriété.',
  100000075:'Vérifier si le jeton a un mécanisme de délai de transfert.',
  100000076:'Vérifier si le commerce du jeton peut être suspendu par des rôles privilégiés.',
  100000077:'Vérifier si le privilège du propriétaire a été renoncé.',
  100000078:'Vérifier si les mécanismes anti-baleines du jeton peuvent être modifiés par des rôles privilégiés.',
  100000079:'Vérifier si la valeur de retour de la fonction decimals() est supérieure ou égale à 5.',
  100000080:"Vérifier si appeler les fonctions mint() et burn() en tant qu'utilisateurs aléatoires entraînera un revert.",
  100000081:'Vérifier si appeler la fonction burn() mettra à jour correctement le totalSupply.',
  100000082:"Vérifier si appeler la fonction burnFrom() mettra à jour correctement l'allocation.",
  100000083:"Vérifier si appeler la fonction transfer() avec le destinataire identique à l'expéditeur de la transaction augmentera le solde de l'expéditeur.",
  100000084:'Vérifier si appeler la fonction transfer() avec un montant supérieur au solde échouera.',
  100000085:"Vérifier si l'allocation du dépensier est mise à jour en conséquence après avoir appelé la fonction transferFrom().",
  100000086:"Vérifier si appeler la fonction transferFrom() utilisera le solde du dépensier.",
  100000087:"Vérifiez si l'allocation est mise à jour correctement après avoir appelé transferFrom(), ou si la transaction est annulée si le montant est invalide.",
  100000088:"Vérifiez si l'appel de la fonction burnFrom() mettra à jour correctement le totalSupply.",
  100000089:"Vérifier si l'autorité d'émission existe.",
  100000090:"Vérifier si l'autorité de gel existe.",
  100000091:'Examiner si les métadonnées peuvent être modifiées.',
  100000092:'Critique  ',
  100000093:'Majeur  ',
  100000094:'Moyen  ',
  100000095:'Mineur  ',
  100000096:'Informatif',
  100000097:'Permission de mint renoncée  ',
  100000098:'Permission de gel renoncée  ',
  100000099:'Peut modifier les métadonnées du token  ',
  100000100:'',
  100000101:'',
  100000102:'',
  100000103:'',
  100000104:'',
  100000105:'',
}
export default fr


// WEBPACK FOOTER //
// ./src/i18n/langs/languageAllen/fr.js